export interface OnComponentDidMount {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7020 (5,5): Call signature, which lacks return-type annotation, implicitly has an 'any' return type.
    // @ts-expect-error
    ();
}

export var onComponentDidMount: OnComponentDidMount;
